// Resilient API URL configuration
// In all environments (preview + production), /api/* is routed to the backend by the platform.
// We use the env URL only when it matches the current browser origin.
// Otherwise, we fall back to relative URLs which always work.
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== 'undefined' && envUrl) {
    try {
      const envOrigin = new URL(envUrl).origin;
      if (envOrigin === window.location.origin) {
        return `${envUrl}/api`;
      }
    } catch (e) {
      // Invalid URL, fall through to relative
    }
  }
  return '/api';
};

export const API = getApiUrl();
